// Where translation JSON comes from. Production: one lazy dynamic import per file, which
// vite.config.ts groups into one chunk per language ("i18n-<lng>"). Unit tests alias this
// module to ./localeSource.sync.ts (see vitest.config.ts) so resources are available
// synchronously, exactly as when everything was statically imported.
const localeLoaders = import.meta.glob<{ default: Record<string, unknown> }>([
  './locales/*/*.json',
  // The public client pages (quotes and invoices opened from a link) read their own file directly and never load i18next.
  '!./locales/*/clientPages.json',
]);

/** Inline resources: none in production, translations are fetched on demand. */
export const INLINE_RESOURCES: Record<string, Record<string, Record<string, unknown>>> | undefined = undefined;

export const ALL_NAMESPACES = Object.keys(localeLoaders)
  .filter((path) => path.startsWith('./locales/en/'))
  .map((path) => path.slice('./locales/en/'.length, -'.json'.length));

export function readLocale(
  language: string,
  namespace: string,
  callback: (err: unknown, data: Record<string, unknown> | null) => void,
): void {
  const load = localeLoaders[`./locales/${language}/${namespace}.json`];
  // Unknown language/namespace combination (e.g. "en-US", or a namespace a language
  // does not ship): empty resource, i18next falls back to English.
  if (!load) return callback(null, {});
  load().then(
    (m) => callback(null, m.default),
    (err) => callback(err, null),
  );
}
